import { AnimatePresence, motion } from 'motion/react';
import React, { useState } from 'react';
import useDebounce from '../../../../../utils/hooks/useDebounce';

const photoNames = [
    'daiangan-medium.jpg',
    'cileklipalet-medium.jpg',
    'deeanacreates-medium.jpg',
    'lidya-isik-medium.jpg',
    'i-rem-dur-medium.jpg'
]

const root = '/edge/photo/'

const totalDuration = 7000;

const Photo: React.FC<{ src: string }> = ({ src }) => {
    return (
        <>
            <motion.img
                key={`${src}aa`}
                src={src}
                style={{ objectPosition: 'cover' }}
                initial={{ filter: 'sepia(70%) saturate(.3)' }}
                animate={{ filter: 'sepia(0%) saturate(1.2)', transition: { duration: (totalDuration / 2) / 1000, ease: 'easeOut' } }}
            />
            <motion.div
                key={src}
                className='size-full absolute top-0 left-0 p-3 z-10'
            >
                <motion.div className='box-border w-full h-full bg-white'
                    key={src}
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 0, transition: { duration: (totalDuration / 2) / 1000, ease: 'easeInOut' } }}
                    exit={{ opacity: 1, transition: { duration: .1 } }}
                />
            </motion.div>
        </>
    )
}

const EdgeMiniCarousel: React.FC = () => {
    const [cursor, setCursor] = useState(0);
    const [triggerCycle, setTriggerCycle] = useState(false);

    useDebounce(() => {
        setTriggerCycle(!triggerCycle);
        setCursor((cursor + 1) % photoNames.length);
    }, totalDuration, [triggerCycle])

    return (
        <div className='w-3/4 aspect-square md:w-[480px] p-3 bg-neutral-800 relative'>
            <AnimatePresence mode='wait'>
                <Photo key={photoNames[cursor]} src={`${root}${photoNames[cursor]}`} />
            </AnimatePresence>
        </div>
    )
}

export default EdgeMiniCarousel;